import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { mockPurchaseRequestService } from '@/services/mock/MockPurchaseRequestService';
import { PurchaseRequest } from '@/types/domain';
import { PurchaseRequestForm } from '../components/PurchaseRequestForm';
import { ROUTES } from '@/constants/routes';

export const EditRequestPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [request, setRequest] = useState<PurchaseRequest | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    mockPurchaseRequestService
      .getRequestById(id)
      .then((req) => {
        if (!req) {
          navigate(ROUTES.REQUESTS.LIST);
          return;
        }
        setRequest(req);
      })
      .catch(() => navigate(ROUTES.REQUESTS.LIST))
      .finally(() => setIsLoading(false));
  }, [id, navigate]);

  if (isLoading || !request) {
    return (
      <div className="p-16 text-center text-xs text-foreground-secondary font-medium font-poppins">
        Loading Requisition for Editing...
      </div>
    );
  }

  return (
    <PurchaseRequestForm
      mode="EDIT_DRAFT"
      initialData={request}
      defaultProcurementType={request.procurementType}
    />
  );
};
